// extracted by mini-css-extract-plugin
export default {"root":"_1nDzn","left":"_35sig","left-side-item-wrapper":"_2gKqt","leftSideItemWrapper":"_2gKqt","right":"_3I8dG","right-side-item-wrapper":"_1hLVf","rightSideItemWrapper":"_1hLVf"};